import { Breadcrumbs } from '@vrplatform/components';
import { Group } from '@mantine/core';
import {
  GeneralLedgerExportButton,
  type Report,
} from './GeneralLedgerExportButton';
import { REPORT_TITLES } from './_const';

export const GeneralLedgerViewPageHeader = ({
  report,
  titleTo,
}: {
  report: Report;
  titleTo?: string;
}) => {
  return (
    <Group mb="xl" justify="space-between" wrap="nowrap">
      <Breadcrumbs
        pageTitle={REPORT_TITLES[report] || '-'}
        to={titleTo}
        crumbs={[
          {
            href: '/reports',
            title: 'Reports',
          },
        ]}
      />
      <GeneralLedgerExportButton report={report} />
    </Group>
  );
};
